import {
  Checkbox,
  Button,
  TextField,
} from "@fanduel/formation-react-components";
import cx from "classnames";
import React, { useState } from "react";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useArticleInfo } from "@/utils/hooks/useArticleContext";
import useEmailNewsletterSignup from "@/utils/hooks/useEmailNewsletterSignup";
import { validEmail } from "@/utils/newsletter";
import styles from "./inputForm.module.scss";

type InputFormProps = {
  location: "top" | "bottom";
};

const InputForm = ({ location }: InputFormProps) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isChecked, setChecked] = useState(false);

  const { emailSignUpMutation } = useEmailNewsletterSignup();
  const { isPending, isSuccess } = emailSignUpMutation;

  const { logAmplitudeEvent } = useAmplitude();

  const {
    title: articleName = "",
    sport = "",
    sportSlug: competition = "",
  } = useArticleInfo();

  const checkValidEmail = (value: string) => {
    const valid = validEmail(value);
    setErrorMessage(valid ? "" : "Please enter a valid email.");
    return valid;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (errorMessage) {
      checkValidEmail(e.target.value);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (checkValidEmail(email)) {
      emailSignUpMutation.mutate(email, {
        onSuccess: () => {
          logAmplitudeEvent("Newsletter Subscription Successful", {
            Module: location === "top" ? "article_header" : "article_footer",
            "Article Name": articleName,
            Competition: competition,
            Sport: sport,
          });
        },
        onError: () => {
          setErrorMessage("Server error. Please try again soon");
        },
      });
    }
  };

  if (isSuccess) {
    return (
      <div
        className={cx(
          location === "bottom" ? styles.bottom : styles.top,
          styles.successMessage
        )}
      >
        <p>You&apos;re in! Thanks.</p>
      </div>
    );
  }
  return (
    <form
      className={cx(
        location === "bottom" ? styles.bottom : styles.top,
        styles.form
      )}
      onSubmit={handleSubmit}
    >
      <TextField
        label=""
        id="email"
        onChange={handleChange}
        value={email}
        placeholder="Type your email..."
        errorMessage={errorMessage}
        isCondensed
        data-testid="email-input"
      />
      <Button
        type="submit"
        disabled={!isChecked}
        label="Subscribe"
        size="small"
        variant="secondary"
        loading={isPending}
      />
      <div className={styles.checkbox}>
        <Checkbox
          id={"ageConfirmationCheckbox"}
          size="md"
          onChange={() => {
            setChecked(!isChecked);
          }}
          checked={isChecked}
        >
          I confirm I am 21+ years of age
        </Checkbox>
      </div>
    </form>
  );
};

export default InputForm;
